import React, { Component } from 'react'

class ContactPhoneFormat extends Component {
  render () {
    let value = this.props.value.replace(/[^A-Z0-9]/gi, '')
    if (!value) {
      return null
    }
    const contactPhone =
      value.slice(0, 0) +
      '(' +
      value.slice(0, 3) +
      ') ' +
      value.slice(3, 6) +
      '-' +
      value.slice(6)

    return <a href={`tel:${value}`}> {contactPhone} </a>
  }
}

export default ContactPhoneFormat
